import Item from "./Item/index";

export default function Sections({ selectedPlanDetail, planType }: any) {
  return (
    <>
      {selectedPlanDetail?.sections?.length > 0 &&
        selectedPlanDetail?.sections?.map((section: any, index: number) => {
          return (
            <Item
              key={section.id}
              section={section}
              index={index}
              planType={planType}
              planId={selectedPlanDetail?.id}
            />
          );
        })}
    </>
  );
}
